import { defineStore } from 'pinia'
import { useAppStore } from './appStore'
import { api } from '../services/api'
import { useToast } from 'vuestic-ui'

export const useCompanyStore = defineStore('company', {
  state: () => ({
    filters: {
      search: '',
      active: true,
      page: 1,
    },
    companies: {},
    company: {},
  }),
  actions: {
    async getCompanies(all = false) {
      const appStore = useAppStore()

      appStore.toggleLoading(true)
      try {
        const response = await api.get(`${all ? '/admin/tenants?all=true' : '/admin/tenants'}`, {
          params: {
            search: this.filters.search,
            active: this.filters.active ? 1 : 0,
            page: this.filters.page,
          },
        })

        this.companies = response.data.tenants
      } catch (e: any) {
        const { init } = useToast()
        if (e?.response?.data?.message) {
          init({ message: e.response.data.message, color: 'danger' })
        } else {
          init({ message: e.message, color: 'danger' })
        }
      } finally {
        appStore.toggleLoading(false)
      }
    },
    async getCompany(id: number) {
      const appStore = useAppStore()

      appStore.toggleLoading(true)
      try {
        const response = await api.get(`/admin/tenants/${id}`)

        this.company = response.data.tenant
      } catch (e: any) {
        const { init } = useToast()
        if (e?.response?.data?.message) {
          init({ message: e.response.data.message, color: 'danger' })
        } else {
          init({ message: e.message, color: 'danger' })
        }
      } finally {
        appStore.toggleLoading(false)
      }
    },
  },
})
